import React, {useMemo} from 'react';
import {SpecialistOngoingConsultation} from '@/interface';
import {Text, StatusBadge, Icon, Button} from '@/ui-kits';
import {ConsultationStatusLabels, ConsultationTypeLabels, SpeclaistConsultationStatusBadgeVariants} from '@/constants';
import {formatConsultationDate, formatDateTime, formatName, timeRemaining} from '@/utils/common_functions';
import {useNavigate} from 'react-router-dom';
import {Routes} from '@/navigation/Routes';
import { DeadlineTimer } from '@/components/deadline-timer';

interface OngoingConsultationCardProps extends SpecialistOngoingConsultation {}

export const OngoingConsultationCard: React.FC<OngoingConsultationCardProps> = props => {
  const {created_at, patient_name, type, status, deadline_at, id} = props;
  const navigate = useNavigate();

  const timeRemainingFormatted = useMemo(() => timeRemaining(deadline_at), [deadline_at]);
  function gotoConsultationSummary(id: number) {
    navigate(Routes.CONSULTATION_SUMMARY.replace(':id', id.toString()));
  }

  

  return (
    <div className="flex flex-col gap-3 border rounded-xl p-4 bg-white border-gray-300">
      {/* Patient Name and Status */}
      <div className="flex flex-col sm:flex-row sm:flex-wrap md:flex-col lg:flex-row lg:flex-wrap items-start gap-2.5 sm:gap-2 mb-0.5 sm:mb-2">
        <div className="flex items-start gap-2 min-w-0 flex-1 sm:flex-[1_1_auto] sm:min-w-0">
          <Icon type="user2" className="flex-shrink-0 size-4 sm:size-5 mt-0.5" />
          <Text variant="subtitle" className="text-ui_blue">
            {formatName(patient_name)}
          </Text>
        </div>
        <StatusBadge
          className="w-fit flex-shrink-0"
          textClassName="text-white !text-xs sm:!text-sm"
          status={SpeclaistConsultationStatusBadgeVariants[status]}>
          {ConsultationStatusLabels[status]}
        </StatusBadge>
      </div>

      <div className="flex flex-col gap-2">
        <Text className="text-ui_input_border_dark font-semibold !text-xs sm:!text-sm">Case ID # {id}</Text>
        <div className="flex items-center gap-2 sm:order-3">
          <Icon type="calender_clock" className="flex-shrink-0" />
          <Text className="text-ui_input_border_dark font-medium !text-xs sm:!text-sm">{formatConsultationDate(created_at, 'long', ' ')}</Text>
        </div>

        <Text className="text-ui_input_border_dark font-semibold !text-xs sm:!text-sm sm:col-span-2">{ConsultationTypeLabels[type]}</Text>
      </div>

      {/* divider */}
      <div className="h-[1px] bg-ui_input_border_dark/30 w-full my-2" />

      {/* button and deadline*/}
      <div className="flex flex-col sm:grid sm:grid-cols-2 items-stretch sm:items-center gap-2 pb-1 px-2">
        {/* deadline */}
        <div className="flex flex-col ">
          <div className="flex items-center gap-1">
            <Icon type="hourglass" />
            <Text className="text-ui_blue font-FigtreeBold font-semibold !text-xs sm:!text-sm">Deadline: {formatDateTime(deadline_at)}</Text>
          </div>
          <Text variant="small" className="text-rejection ml-6 !text-xs sm:!text-sm">
            <DeadlineTimer deadline_at={deadline_at}/>
          </Text>
        </div>

        {/* CTA */}
        <Button variant="primary" title="View Case" className="py-2 w-full sm:w-auto" textClassName="text-sm" onClick={() => gotoConsultationSummary(id)} />
      </div>
    </div>
  );
};
